// extracted by mini-css-extract-plugin
export var actionText = "_ki-4";
export var container = "_ki-0";
export var leftSection = "_ki-1";
export var rightSection = "_ki-2";
export var settingsButton = "_ki-6";
export var settingsIcon = "_ki-7";
export var shortcut = "_ki-5";
export var shortcutGroup = "_ki-3";